import { render, staticRenderFns } from "./stopNewTable.vue?vue&type=template&id=0fc4b198"
import script from "./stopNewTable.vue?vue&type=script&lang=js"
export * from "./stopNewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports